import { useState, useEffect } from "react";
import styled from "styled-components";
import { CommonConfig } from "../../shared/Constants";

interface IPage {
    isActive: boolean;
}

const Page = styled.span<IPage>`
    color: black;
    float: left;
    padding: 8px 16px;
    text-decoration: none;
    transition: background-color 0.3s;
    cursor: pointer;

    ${(props) =>
        props.isActive
            ? `background-color: dodgerblue; color: white;`
            : "&:hover {background-color: #ddd;}"}
`;

interface IPagination {
    pages: number;
    currentIndex: number;
    handleIndex: (page: number) => void;
}

const Pagination: React.FC<IPagination> = ({
    pages,
    currentIndex,
    handleIndex,
}) => {
    const [items, setItems] = useState<number[]>([]);

    useEffect(() => {
        const limit =
            pages < CommonConfig.PAGINATION_LIMIT
                ? pages
                : CommonConfig.PAGINATION_LIMIT;

        const arrPages = [];
        for (let i = 1; i <= limit; i++) {
            if (currentIndex + limit <= pages) arrPages.push(currentIndex + i);
            else arrPages.push(pages - limit + i);
        }
        setItems(arrPages);
    }, [currentIndex, pages]);

    if (pages === 0) return null;

    const handleNext = () => {
        if (currentIndex < pages - 1) {
            handleIndex(currentIndex + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex >= 1) {
            handleIndex(currentIndex - 1);
        }
    };

    const onPageClick = (page: number) => {
        handleIndex(page - 1);
    };

    return (
        <div>
            <Page isActive={false} onClick={handlePrev}>
                &laquo;
            </Page>
            {items.map((v, i) => (
                <Page
                    key={i}
                    isActive={v === currentIndex + 1}
                    onClick={() => onPageClick(v)}
                >
                    {v}
                </Page>
            ))}
            <Page isActive={false} onClick={handleNext}>
                &raquo;
            </Page>
        </div>
    );
};

export default Pagination;
